import { render, staticRenderFns } from "./DSTransactionCard.vue?vue&type=template&id=10256198&"
import script from "./DSTransactionCard.vue?vue&type=script&lang=js&"
export * from "./DSTransactionCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports